export const REQUIRED_PROMPT_VARS = ['问题列表', 'ASR识别结果']

export function validatePromptTemplate (template) {
  const text = template ? String(template).trim() : ''
  if (!text) {
    return true
  }
  for (let i = 0; i < REQUIRED_PROMPT_VARS.length; i++) {
    const varName = REQUIRED_PROMPT_VARS[i]
    if (text.indexOf('{{' + varName + '}}') < 0) {
      return false
    }
  }
  return true
}

export function createEmptyQuestion (key, item) {
  const source = item || {}
  return {
    _key: key,
    alias: source.alias || '',
    question: source.question || '',
    risk_answer: source.risk_answer || '',
  }
}



// WEBPACK FOOTER //
// ./src/views/audio-asr-check/audio-asr-check.prompt.js